import {
  CivilParty,
  SupportDocument,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import { JudgementOnMeritsDoc } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { VictimType } from 'typings/globalTypes';

export const CLAIM = {
  POLICY_NUMBER: 'policyNumber',
  CLAIM_NUMBER: 'claimNumber',
  PV_NUMBER: 'pvNumber',
  LOSS_LOCATION: 'lossLocation',
  LOSS_LOCATION_LABEL: 'lossLocationLabel',
  LOSS_DATE: 'lossDate',
  LOSS_HOUR: 'lossHour',
  TOTAL_INJURED_VICTIMS: 'totalInjuredVictims',
  TOTAL_DECEASED_VICTIMS: 'totalDeceasedVictims',
  AUTHORITY_TYPE: 'authorityType',
  AUTHORITY_NAME: 'authorityName',
  HAS_MATERIAL_DAMAGES: 'hasMaterialDamages',
  IS_JUDICIAL_PROCEDURE: 'isJudicialProcedure',
  JUDICIAL_PROCEDURE_ID: 'judicialProcedureId',
  ACCIDENT_DESCRIPTION: 'accidentDescription',
  DRIVER_ID: 'driverId',
  STATUS: 'status',
  VEHICULE_ID: 'vehiculeId',
  CREATED_BY: 'createdBy',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  CIN: 'cin',
  REGISTRATION_NUMBER: 'registrationNumber',
  CREATED_AT: 'createdAt',
  COUNTRY_ID: 'countryId',
  FIRM_REFERENCE: 'firmReference',
  SUSPICIOUS: 'suspicious',
  SCALE_CASE_KEY: 'scaleCaseKey',
  ACCIDENT_CIRCONSTANCE_KEY: 'accidentCirconstanceKey',
  ACCIDENT_CIRCONSTANCE: 'accidentCirconstance',
  RESPONSABILITY_KEY: 'responsabilityKey',
  RESPONSABILITY_SHARE: 'responsibilityShare',
  INTERVENANT_TYPE: 'intervenantTypeCode',
  MANAGEMENT_MODE: 'managementMode',
  JURISDICTION_ID: 'jurisdictionId',
  OPENING_TYPE: 'openingType',
  OPENING_STATE: 'openingState',
  COURT_NUMBER: 'courtNumber',
  PROCEDURE_NATURE_ID: 'procedureNature',
  IS_PROVISIONAL: 'isProvisional',
  PROVISIONAL_CLAIM_REFERENCE: 'provisionalClaimReference',
};

export const DRIVER = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  CIN: 'cin',
  SEX: 'sex',
  LICENSE_START_DATE: 'driverLicenseIssueDate',
  LICENSE_CATEGORY: 'driverLicenseCategoryId',
  LICENSE_ID: 'driverLicenseId',
  DATE_OF_BIRTH: 'dateOfBirth',
  IS_DRIVER_THE_INSURED: 'isDriverTheInsured',
  DRIVER_QUALITY: 'driverQualityId',
};

export const VICTIM = {
  ID: 'id',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  CIN: 'cin',
  TELEPHONE_NUMBER: 'telephoneNumber',
  PROCEDURE_ID: 'procedureId',
  DAMAGE_TYPE: 'damageType',
  PROFESSION: 'profession',
  PROFESSION_TYPE: 'professionCode',
  CITY: 'city',
  ADDRESS: 'address',
  ITT: 'itt',
  CLAIM_ID: 'claimId',
  IS_EXCLUDED: 'isExcluded',
  WORK_ACCIDENT_ID: 'workAccidentId',
  CLASS_KEY: 'classKey',
  INJURY_POST_KEY: 'injuryPostKey',
  DATE_OF_BIRTH: 'dateOfBirth',
  QUALITY_KEY: 'qualityKey',
  OPPOSITION: 'opposition',
  VICTIM_KEY: 'victimKey',
  BENEFICIARIES: 'beneficiaries',
  GENDER: 'gender',
  NUMBER_OF_SPOUSE: 'numberOfSpouse',
  NUMBER_OF_DEPENDENTS: 'numberOfDependents',
  NUMBER_OF_CHILDREN: 'numberOfChildren',
  ANNUAL_INCOME: 'annualOfIncome',
  IS_DELETED: 'isDeleted',
  ITT_AVAILABILITY: 'ittAvailability',
  VEHICLE_PASSENGER_ID: 'vehiclePassengerId',
} as const;

export const TUTOR = {
  ID: 'id',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  CIN: 'cin',
  IS_DELETED: 'isDeleted',
} as const;

export const JUDGEMENT_ON_MERITS_VICTIM = {
  COMPENSATION_AMOUNT: 'compensationAmount',
  MEDICAL_FEES: 'medicalFees',
  FUNERAL_FEES: 'funeralFees',
};
export const BENEFICIARY = {
  ID: 'id',
  BENEFICIARY_TYPE: 'beneficiaryType',
  FIRST_NAME: 'firstName',
  FRAIS: 'funeralFees',
  MEDICAL_FFES: 'medicalFees',
  HANDICAP_INDICATOR: 'handicapIndicator',
  DEPENDENT_INDICATOR: 'dependentIndicator',
  LAST_NAME: 'lastName',
  TYPE: 'type',
  AGE: 'age',
  VICTIM_KEY: 'victimKey',
  PREJUDICE_MATERIEL: 'materialPrejudice',
  PREJUDICE_MORAL: 'moralePrejudice',
  JUDGEMENT_AMOUNT: 'judgementAmount',
  DATE_OF_BIRTH: 'dateOfBirth',
  IS_NEW: 'isNew',
  BENEFICIARY_WITHOUT_COMPENSATION: 'beneficiaryWithoutCompensation',
} as const;

export const EMPTY_CLAIM = {
  [CLAIM.PV_NUMBER]: '',
  [CLAIM.LOSS_LOCATION]: '',
  [CLAIM.LOSS_DATE]: '',
  [CLAIM.LOSS_HOUR]: '',
  [CLAIM.TOTAL_INJURED_VICTIMS]: '',
  [CLAIM.TOTAL_DECEASED_VICTIMS]: '',
  [CLAIM.AUTHORITY_TYPE]: '',
  [CLAIM.AUTHORITY_NAME]: '',
  [CLAIM.IS_JUDICIAL_PROCEDURE]: '',
  [CLAIM.JUDICIAL_PROCEDURE_ID]: null,
  [CLAIM.RESPONSABILITY_SHARE]: '',
  [CLAIM.ACCIDENT_DESCRIPTION]: '',
  [CLAIM.HAS_MATERIAL_DAMAGES]: '',
  [CLAIM.CREATED_BY]: '',
  [CLAIM.FIRST_NAME]: '',
  [CLAIM.LAST_NAME]: '',
  [CLAIM.CIN]: '',
  [CLAIM.REGISTRATION_NUMBER]: '',
  [CLAIM.COUNTRY_ID]: '',
  [CLAIM.FIRM_REFERENCE]: '',
  [CLAIM.SUSPICIOUS]: false,
  [CLAIM.SCALE_CASE_KEY]: '',
  [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]: '',
  [CLAIM.ACCIDENT_CIRCONSTANCE]: '',
  [CLAIM.RESPONSABILITY_KEY]: '',
  [CLAIM.RESPONSABILITY_SHARE]: '',
};

export const VEHICULE = {
  ID: 'id',
  BRAND: 'brand',
  REGISTRATION_NUMBER: 'registrationNumber',
  OPPOSING_PARTY: 'opposingParty',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  POLICY_NUMBER_OPPOSING: 'policyNumberOpposing',
  CERTIFICATE_NUMBER_OPPOSING: 'certificateNumberOpposing',
  CLAIM_NUMBER_OPPOSING: 'claimNumberOpposing',
  REGISTRATION_NUMBER_TYPE: 'registrationNumberTypeId',
  RESPONSABILITY: 'responsability',
  RESPONSABILITY_RATE: 'responsabilityRate',
} as const;

export const DOCUMENT = {
  URL: 'url',
  NAME: 'name',
  TYPE: 'type',
  CLAIM_ID: 'claimId',
  IS_INDEXED: 'isIndexed',
  IS_VISIBLE: 'isVisible',
  DOCUMENTUM_ID: 'documentumId',
} as const;

export const EMPTY_DOCUMENT = {
  [DOCUMENT.URL]: '',
  [DOCUMENT.NAME]: '',
  [DOCUMENT.TYPE]: '',
  [DOCUMENT.CLAIM_ID]: '',
  [DOCUMENT.IS_INDEXED]: false,
  [DOCUMENT.IS_VISIBLE]: true,
  [DOCUMENT.DOCUMENTUM_ID]: null,
};

export const EMPTY_DRIVER = {
  [DRIVER.FIRST_NAME]: '',
  [DRIVER.LAST_NAME]: '',
  [DRIVER.CIN]: '',
  [DRIVER.SEX]: '',
  [DRIVER.LICENSE_START_DATE]: null,
  [DRIVER.LICENSE_ID]: null,
  [DRIVER.DATE_OF_BIRTH]: undefined,
  [DRIVER.LICENSE_CATEGORY]: null,
  [DRIVER.IS_DRIVER_THE_INSURED]: '',
  [DRIVER.DRIVER_QUALITY]: null,
};

export const EMPTY_VEHICULE = {
  [VEHICULE.BRAND]: '',
  [VEHICULE.REGISTRATION_NUMBER]: '',
  [VEHICULE.OPPOSING_PARTY]: '',
  [VEHICULE.FIRST_NAME]: '',
  [VEHICULE.LAST_NAME]: '',
};

export const EMPTY_VICTIM = {
  [VICTIM.FIRST_NAME]: '',
  [VICTIM.LAST_NAME]: '',
  [VICTIM.CIN]: '',
  [VICTIM.TELEPHONE_NUMBER]: '',
  [VICTIM.PROCEDURE_ID]: '',
  [VICTIM.DAMAGE_TYPE]: '',
  [VICTIM.PROFESSION]: '',
  [VICTIM.PROFESSION_TYPE]: '',
  [VICTIM.CITY]: '',
  [VICTIM.ADDRESS]: '',
  [VICTIM.ITT]: '',
  [VICTIM.CLAIM_ID]: '',
  [VICTIM.IS_EXCLUDED]: false,
  [VICTIM.WORK_ACCIDENT_ID]: '',
  [VICTIM.CLASS_KEY]: '',
  [VICTIM.INJURY_POST_KEY]: '',
  [VICTIM.DATE_OF_BIRTH]: '',
  [VICTIM.QUALITY_KEY]: '',
  [VICTIM.OPPOSITION]: false,
  [VICTIM.BENEFICIARIES]: [],
  [VICTIM.GENDER]: '',
  [VICTIM.NUMBER_OF_CHILDREN]: 0,
  [VICTIM.NUMBER_OF_DEPENDENTS]: 0,
  [VICTIM.NUMBER_OF_SPOUSE]: 0,
  [VICTIM.ANNUAL_INCOME]: '',
  [VICTIM.IS_DELETED]: false,
};

export const EMPTY_BENEFICIARY = {
  [BENEFICIARY.BENEFICIARY_TYPE]: 0,
  [BENEFICIARY.FIRST_NAME]: '',
  [BENEFICIARY.LAST_NAME]: '',
  [BENEFICIARY.AGE]: '',
  [BENEFICIARY.HANDICAP_INDICATOR]: false,
  [BENEFICIARY.DEPENDENT_INDICATOR]: true,
  [BENEFICIARY.FRAIS]: null,
  [BENEFICIARY.TYPE]: '',
  [BENEFICIARY.VICTIM_KEY]: '',
  [BENEFICIARY.DATE_OF_BIRTH]: '',
};

export const EMPTY_BENEFICIARY_JUDGEMENT_ON_MERITS = {
  [BENEFICIARY.BENEFICIARY_TYPE]: '',
  [BENEFICIARY.FIRST_NAME]: '',
  [BENEFICIARY.LAST_NAME]: '',
  [BENEFICIARY.AGE]: '',
  [BENEFICIARY.DATE_OF_BIRTH]: '',
  [BENEFICIARY.TYPE]: '',
  [BENEFICIARY.VICTIM_KEY]: '',
  [BENEFICIARY.PREJUDICE_MATERIEL]: 0,
  [BENEFICIARY.PREJUDICE_MORAL]: 0,
  [BENEFICIARY.JUDGEMENT_AMOUNT]: null,
  [BENEFICIARY.FRAIS]: null,
  [BENEFICIARY.MEDICAL_FFES]: null,
  [BENEFICIARY.HANDICAP_INDICATOR]: false,
  [BENEFICIARY.DEPENDENT_INDICATOR]: true,
  [BENEFICIARY.BENEFICIARY_WITHOUT_COMPENSATION]: {},
};

export const EMPTY_CLAIM_TO_PREOPEN = {
  claim: EMPTY_CLAIM,
  driver: EMPTY_DRIVER,
  vehicule: EMPTY_VEHICULE,
  victims: [],
  documents: [],
  opposingParty: {
    hasMaterialDammage: null,
    vehicules: [],
  },
};

export const VALIDATION_DECISION = {
  MANAGEMENT_MODE: 'managementMode',
  CIRCUMSTANCE: 'circumstance',
  RESPONSIBILITY: 'responsabilityRate',
  COMMENT: 'comments',
  CIRCUMSTANCE_CODE: 'circumstanceCode',
  SCALE_CASE: 'scaleCaseCode',
  CHANGE_NATURE: 'changeNature',
  CONFIRMATION_PREOPENING: 'confirmationPreopening',
};

export const EMPTY_VALIDATION_DECISION = {
  [VALIDATION_DECISION.MANAGEMENT_MODE]: '',
  [VALIDATION_DECISION.CIRCUMSTANCE]: '',
  [VALIDATION_DECISION.RESPONSIBILITY]: '',
  [VALIDATION_DECISION.COMMENT]: '',
  [VALIDATION_DECISION.CIRCUMSTANCE_CODE]: '',
  [VALIDATION_DECISION.SCALE_CASE]: '',
  [VALIDATION_DECISION.CHANGE_NATURE]: '',
  [VALIDATION_DECISION.CONFIRMATION_PREOPENING]: '',
};

export const REJECTION_DECISION = {
  REJECTION_REASON: 'rejectionReasons',
  OTHER_REASON: 'otherRejectionReason',
};

export const EMPTY_REJECTION_DECISION = {
  [REJECTION_DECISION.OTHER_REASON]: '',
  [REJECTION_DECISION.REJECTION_REASON]: new Set(),
};

export const LISTINGS = {
  CITIES: 'villes',
  STACKHOLDERS: 'intervenants',
  STACKHOLDER_TYPE: 'intervenantType',
  SUB_SERVICES: 'sousServices',
  SERVICES: 'services',
  ZONE_CODES: 'subService',
  CONVICTION: 'conviction',
  INTERVENANT_TYPE: 'intervenantType',
  INTERVENANT_NAME: 'intervenants',
  INACTIFS_INTERVENANT_NAME: 'inactiveIntervenants',
  JURISDICTION: 'jurisdiction',
  COURT_FILE: 'courtFile',
  EXPERTISE: 'expertise',
  PROCEDURE_NATURE: 'procedureNature',
  THIRD_PARTY_APPEALS: 'thirdPartyAppeals',
  PRETIUM_DOLORIS: 'pretiumDoloris',
  CAREER_PREJUDICE: 'careerPrejudice',
  SCHOOLING_PREJUDICE: 'schoolingPrejudice',
  AESTHETIC_DAMAGE_WITH_CONSEQUENCE: 'aestheticDamageWithConsequence',
  AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE: 'aestheticDamageWithoutConsequence',
  JUDGEMENT_ON_MERITS_CONTESTATION_REASONS:
    'judgementOnMeritsContestationReasons',
  DISCLAIMER_WARRANTY_REASONS: 'disclaimerWarrantyReasons',
  ASSIGNMENT_MANAGER: 'assignmentManager',
  MAPPING_LAWYER_JURISDICTION: 'mappingLawyerJurisdiction',
  FRAUD_MOTIF: 'fraudMotif',
};

export const JUDGEMENT_ADD_DOCUMENT = {
  JUDGEMENT_DATE: 'judgementDate',
  CONVICTION_ID: 'convictionId',
  RESPONSABILITY_SHARE: 'responsibilityShare',
  URL: 'url',
  NAME: 'name',
  TYPE: 'type',
  STATUS: 'status',
  REJECTION_REASON: 'rejectionReason',
  DOCUMENTUM_ID: 'documentumId',
} as const;
export const INCOME_CERTIFICATE = {
  VICTIM_ID: 'victimId',
  STATUS: 'status',
  URL: 'url',
  NAME: 'name',
  TYPE: 'type',
  INCOME: 'income',
} as const;

export const EMPTY_JUDGEMENT_ADD_DOCUMENT = {
  [JUDGEMENT_ADD_DOCUMENT.JUDGEMENT_DATE]: undefined,
  [JUDGEMENT_ADD_DOCUMENT.CONVICTION_ID]: '',
  [JUDGEMENT_ADD_DOCUMENT.RESPONSABILITY_SHARE]: null,
  [JUDGEMENT_ADD_DOCUMENT.NAME]: '',
  [JUDGEMENT_ADD_DOCUMENT.URL]: '',
  [JUDGEMENT_ADD_DOCUMENT.TYPE]: '',
  [JUDGEMENT_ADD_DOCUMENT.STATUS]: 'PENDING',
  [JUDGEMENT_ADD_DOCUMENT.REJECTION_REASON]: '',
  [JUDGEMENT_ADD_DOCUMENT.DOCUMENTUM_ID]: null,
};

export const EMPTY_ADD = {
  ...EMPTY_JUDGEMENT_ADD_DOCUMENT,
  expertises: [],
};
export const EMPTY_INCOME_CERTIFICATE = {
  [INCOME_CERTIFICATE.INCOME]: null,
  [INCOME_CERTIFICATE.VICTIM_ID]: '',
  [INCOME_CERTIFICATE.URL]: null,
  [INCOME_CERTIFICATE.TYPE]: null,
  [INCOME_CERTIFICATE.NAME]: null,
};
export const EMPTY_DOCUMENT_CERTIFICATE = {
  [INCOME_CERTIFICATE.URL]: '',
  [INCOME_CERTIFICATE.TYPE]: '',
  [INCOME_CERTIFICATE.NAME]: '',
};

export const EMPTY_CIVIL_PARTY: CivilParty = {
  url: '',
  name: '',
  type: '',
  victims: [] as VictimType[],
};

export const EMPTY_SUPPORT_DOCUMENT: SupportDocument = {
  url: '',
  name: '',
  type: '',
};

export const DETAIL_JUGEMENT_ADD = {
  PROCEDURE_NATURE_ID: 'procedureNatureId',
  JURISDICTION_ID: 'jurisdictionId',
  IS_INSURED_SUED: 'isInsuredSued',
  SUED_PARTIES: 'suedParties',
  PACKAGE_CONTINUATION: 'packageContinuation',
  COURT_FILE: 'courtFile',
  HEARING_DATE: 'hearingDate',
} as const;

export const EMPTY_DETAIL = {
  [DETAIL_JUGEMENT_ADD.PROCEDURE_NATURE_ID]: '',
  [DETAIL_JUGEMENT_ADD.JURISDICTION_ID]: '',
  [DETAIL_JUGEMENT_ADD.IS_INSURED_SUED]: null,
  [DETAIL_JUGEMENT_ADD.SUED_PARTIES]: [],
  [DETAIL_JUGEMENT_ADD.PACKAGE_CONTINUATION]: null,
  [DETAIL_JUGEMENT_ADD.COURT_FILE]: null,
};
export const DETAIL_APPEAL_ADD = {
  PROCEDURE_NATURE_ID: 'procedureNatureId',
  JURISDICTION_ID: 'jurisdictionId',
  IS_INSURED_SUED: 'isInsuredSued',
  SUED_PARTIES: 'suedParties',
  PACKAGE_CONTINUATION: 'packageContinuation',
  COURT_FILE: 'courtFile',
} as const;
export const EMPTY_APPEAL_ADD = {
  [DETAIL_APPEAL_ADD.PROCEDURE_NATURE_ID]: '',
  [DETAIL_APPEAL_ADD.JURISDICTION_ID]: '',
  [DETAIL_APPEAL_ADD.IS_INSURED_SUED]: null,
  [DETAIL_APPEAL_ADD.SUED_PARTIES]: [],
  [DETAIL_APPEAL_ADD.PACKAGE_CONTINUATION]: null,
  [DETAIL_APPEAL_ADD.COURT_FILE]: null,
};
export const EMPTY_JUDGEMENT_ON_MERITS_DOC: JudgementOnMeritsDoc = {
  url: '',
  name: '',
  type: '',
};

export const CIVIL_PARTY = {
  URL: 'url',
  TYPE: 'type',
  NAME: 'name',
};

export const TIMELINE_REGULATION_STATUS = {
  PENDING: 'PENDING',
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
};

export const CLAIM_STATUS = {
  PENDING: 'PENDING',
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
  PENDING_INFO_MODIFICATION: 'PENDING_INFO_MODIFICATION',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
};

export const PROCEDURE_STATUSES = {
  VALIDATED: 'VALIDATED',
  TO_EDIT: 'TO_EDIT',
  PENDING: 'PENDING',
  MODIFIED: 'MODIFIED',
  CONTESTED: 'CONTESTED',
  VALIDATED_WITHOUT_CONTESTATION: 'VALIDATED_WITHOUT_CONTESTATION',
  APPEL: 'APPEL',
  OPPOSITION: 'OPPOSITION',
  APPLICATION_ANNULMENT: 'APPLICATION_ANNULMENT',
  REJECTED: 'REJECTED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
};
export const CIVIL_PROCEEDING_INFORMATIONS_FIELDS = {
  HEARING_DATE: 'hearingDate',
  DATE_RECEIPT_REQUEST: 'dateReceiptRequest',
  COURT_NUMBER: 'courtNumber',
  OPPOSING_LAWYER: 'opposingLawyer',
  CIRCUMSCRIPTION: 'circonscription',
  DEGREE_OF_JURISDICTION: 'jurisdictionDegreeId',
  DOCUMENT: 'document',
  VICTIM: 'victim',
  TOWN: 'town',
  ASSIGNED_LAWYER: 'assignedLawyer',
  ASSIGNED_LAWYERS: 'assignedLawyers',
};
export const CIVIL_PROCEEDING_LAWYER_INFORMATIONS_FIELDS = {
  HEARING_DATE: 'hearingDate',
  DATE_RECEIPT_REQUEST: 'dateReceiptRequest',
  COURT_NUMBER: 'courtNumber',
  OPPOSING_LAWYER: 'opposingLawyer',
  CIRCUMSCRIPTION: 'circonscription',
  DEGREE_OF_JURISDICTION: 'jurisdictionDegreeId',
  DOCUMENT: 'document',
  VICTIM: 'victim',
  TOWN: 'town',
};
export const PROCEDURE_STEPS = {
  JUDGEMENT_ADD: 'JUDGEMENT_ADD',
  EXPERT_REPORT: 'EXPERT_REPORT',
  JUDGEMENT_ON_MERITS: 'JUDGEMENT_ON_MERITS',
  JUDGEMENT_APPEAL: 'APPEAL_JUDGEMENT',
  ARRET_ADD: 'ARRET_ADD',
  ARRET_ON_MERITS: 'ARRET_ON_MERITS',
};

export const JUDGEMENT = {
  STATUS: 'status',
  CREATOR: 'creator',
  VALIDATOR: 'validator',
  STEP: 'step',
};

export const EXPERTISE = {
  EXPERTISE_ID: 'expertiseId',
};

export const VICTIM_EXPERTISE_FIELDS = {
  ID: 'id',
  VICTIM_ID: 'victimId',
  FIXED_ANNUAL_INCOME: 'fixedAnnualIncome',
  ITT: 'itt',
  INJURY_POST_KEY: 'injuryPostKey',
  IPP: 'ipp',
  PRETIUM_DOLORIS: 'pretiumDoloris',
  AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE: 'aestheticDamageWithoutConsequence',
  AESTHETIC_DAMAGE_WITH_CONSEQUENCE: 'aestheticDamageWithConsequence',
  THIRD_PARTY_APPEAL: 'thirdPartyAppeal',
  STATUS: 'status',
  COURT_MANAGER: 'courtManager',
  GROUNDS_FOR_OBJECTION: 'groundsForObjection',
  VICTIM_EXPERTISE_DOCUMENTS: 'victimExpertiseDocuments',
  CAREER_PREJUDICE: 'careerPrejudice',
  SCHOOLING_PREJUDICE: 'schoolingPrejudice',
  MEDICAL_PHARMACEUTICAL_FEES: 'medicalPharmaceuticalFees',
  VICTIM_REVENUE: 'victimRevenue',
  CAUSALITY_LINK: 'causalityLink',
  IS_DEATH_RELATED_TO_CLAIM: 'isDeathRelatedToClaim',
  EXPERTISE_JUDGEMENT_ADD_DOCUMENT_ID: 'expertiseJudgementAddDocumentId',
  EXPERTISE_ID: 'expertiseId',
  CONSULTANCY_REPORT_DOCUMENT: 'consultancyReportDocument',
  VALIDATOR: 'validator',
  HAS_DECISION: 'hasDecision',
  REJECTION_REASON: 'rejectionReason',
  LAWYER_CODE: 'lawyerCode',
  CERTIFICAT_DESCRIPTION: 'certificatDescription',
  CLINICAL_EXAMINATION: 'clinicalExamination',
  INJURY_DESCRIPTION: 'injuryDescription',
} as const;

export const COURT_JUDGEMENT_APPEAL_FIELDS = {
  CONVICTION: 'conviction',
  DOCUMENT: 'document',
} as const;
export const MAGISTRAT_RULING_APPEAL_FIELDS = {
  MAGISTRAT_RULING: 'magistrateRuling',
} as const;

export const MECHANICAL_EXPERTISE_JUDGEMENT_CIVIL_APPEAL_FIELDS = {
  DAMAGE_AMOUNT: 'damageAmount',
} as const;

export const VEHICULE_EXPERTISE_FIELDS = {
  ID: 'id',
  VEHICULE_ID: 'vehiculeId',
  FIXED_ANNUAL_INCOME: 'fixedAnnualIncome',
  DAMAGE_AMOUNT: 'damageAmount',
  STATUS: 'status',
  COURT_MANAGER: 'courtManager',
  GROUNDS_FOR_OBJECTION: 'groundsForObjection',
  VEHICULE_EXPERTISE_DOCUMENTS: 'vehiculeExpertiseDocuments',
  EXPERTISE_JUDGEMENT_ADD_DOCUMENT_ID: 'expertiseJudgementAddDocumentId',
  EXPERTISE_ID: 'expertiseId',
  CONSULTANCY_REPORT_DOCUMENT: 'consultancyReportDocument',
  VALIDATOR: 'validator',
  REJECTION_REASON: 'rejectionReason',
  LAWYER_CODE: 'lawyerCode',
  UPDATED_BY: 'updatedBy',
} as const;

export const EXPERT_REPORT_FIELDS = {
  VICTIM_EXPERTISES: 'victimExpertises',
  VEHICULE_EXPERTISES: 'vehiculeExpertises',
} as const;

export const EXPERTISES = {
  MECHANICAL_EXPERTISE: 'mechanicalExpertise',
  MEDICAL_EXPERTISE: 'medicalExpertise',
  ACCOUNTING_EXPERTISE: 'accountingExpertise',
} as const;

export const EXPERTISES_FIELDS = {
  MECHANICAL_EXPERTISE: 'damageAmount',
  PROVISIONNAL_EXECUTION: 'provisionalExecution',
  CALCULATED_REVENUE: 'calculatedRevenue',
  RESPONSIBILITY_SHARE: 'responsibilityShare',
  REVENUE: 'revenue',
} as const;

export const EMPTY_VICTIM_EXPERTISE = {
  [VICTIM_EXPERTISE_FIELDS.VICTIM_ID]: undefined,
  [VICTIM_EXPERTISE_FIELDS.FIXED_ANNUAL_INCOME]: undefined,
  [VICTIM_EXPERTISE_FIELDS.ITT]: undefined,
  [VICTIM_EXPERTISE_FIELDS.IPP]: undefined,
  [VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS]: undefined,
  [VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE]: undefined,
  [VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE]: undefined,
  [VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL]: undefined,
  [VICTIM_EXPERTISE_FIELDS.STATUS]: '',
  [VICTIM_EXPERTISE_FIELDS.COURT_MANAGER]: undefined,
  [VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE]: undefined,
  [VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE]: undefined,
  [VICTIM_EXPERTISE_FIELDS.GROUNDS_FOR_OBJECTION]: undefined,
  [VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES]: undefined,
  [VICTIM_EXPERTISE_FIELDS.EXPERTISE_JUDGEMENT_ADD_DOCUMENT_ID]: undefined,
  [VICTIM_EXPERTISE_FIELDS.VICTIM_EXPERTISE_DOCUMENTS]: [],
  [VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE]: undefined,
  [VICTIM_EXPERTISE_FIELDS.EXPERTISE_ID]: undefined,
  [VICTIM_EXPERTISE_FIELDS.VALIDATOR]: undefined,
  [VICTIM_EXPERTISE_FIELDS.CONSULTANCY_REPORT_DOCUMENT]: {},
};
export const EMPTY_CIVIL_PROCEEDING_INFO_FIELDS = {
  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.HEARING_DATE]: '',
  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.COURT_NUMBER]: '',
  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.DATE_RECEIPT_REQUEST]: '',
  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.OPPOSING_LAWYER]: '',
  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.CIRCUMSCRIPTION]: '',
  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.DEGREE_OF_JURISDICTION]: '',
  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.VICTIM]: null,
  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.ASSIGNED_LAWYER]: null,
  [CIVIL_PROCEEDING_INFORMATIONS_FIELDS.ASSIGNED_LAWYERS]: [],
};
export const EMPTY_VEHICULE_EXPERTISE = {
  [VEHICULE_EXPERTISE_FIELDS.VEHICULE_ID]: undefined,
  [VEHICULE_EXPERTISE_FIELDS.FIXED_ANNUAL_INCOME]: undefined,
  [VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT]: undefined,
  [VEHICULE_EXPERTISE_FIELDS.STATUS]: undefined,
  [VEHICULE_EXPERTISE_FIELDS.COURT_MANAGER]: undefined,
  [VEHICULE_EXPERTISE_FIELDS.GROUNDS_FOR_OBJECTION]: undefined,
  [VEHICULE_EXPERTISE_FIELDS.VEHICULE_EXPERTISE_DOCUMENTS]: [],
  [VEHICULE_EXPERTISE_FIELDS.EXPERTISE_JUDGEMENT_ADD_DOCUMENT_ID]: undefined,
  [VEHICULE_EXPERTISE_FIELDS.EXPERTISE_ID]: undefined,
  [VEHICULE_EXPERTISE_FIELDS.CONSULTANCY_REPORT_DOCUMENT]: {},
  [VEHICULE_EXPERTISE_FIELDS.VALIDATOR]: undefined,
};

export const EMPTY_EXPERT_REPORT = {
  [EXPERT_REPORT_FIELDS.VICTIM_EXPERTISES]: [EMPTY_VICTIM_EXPERTISE],
  [EXPERT_REPORT_FIELDS.VEHICULE_EXPERTISES]: [EMPTY_VEHICULE_EXPERTISE],
};

export const EMPTY_JUDGEMENT_DOCUMENT = {
  [DOCUMENT.URL]: '',
  [DOCUMENT.NAME]: '',
  [DOCUMENT.TYPE]: '',
};

export const EMPTY_EXPERTISE = {
  [EXPERTISES.MECHANICAL_EXPERTISE]: [],
  [EXPERTISES.MEDICAL_EXPERTISE]: [],
  [EXPERTISES.ACCOUNTING_EXPERTISE]: [],
};
export const EXPERTISE_TYPE = {
  VEHICULE: 'vehiculeId',
  VICTIM: 'victimId',
};
export const EMPTY_COURT_JUDGEMENT_APPEAL = {
  [COURT_JUDGEMENT_APPEAL_FIELDS.CONVICTION]: undefined,
  [COURT_JUDGEMENT_APPEAL_FIELDS.DOCUMENT]: {},
};
export const EMPTY_MAGISTRATE_JUDGEMENT_APPEAL = {
  [MAGISTRAT_RULING_APPEAL_FIELDS.MAGISTRAT_RULING]: undefined,
};

export const APPEAL_CIVIL_MECHANICAL_EXPERTISE_FIELDS = {
  DAMAGE_AMOUNT: 'damageAmount',
  DOCUMENT: 'document',
};

export const APPEAL_CIVIL_MEDICAL_EXPERTISE_FIELDS = {
  COMPENSATION_AMOUNT: 'compensationAmount',
  CALCULATED_COMPENSATION_AMOUNT: 'calculatedCompensationAmount',
  DOCUMENT: 'document',
} as const;
export const APPEAL_CIVIL_ACCOUNTING_EXPERTISE_FIELDS = {
  EVALUATION_AMOUNT: 'evaluationAmount',
  CALCULATED_REVENUE: 'calculatedRevenue',
  DOCUMENT: 'document',
} as const;
export const EMPTY_APPEAL_CIVIL_MEDICAL_EXPERTISE = {
  [APPEAL_CIVIL_MEDICAL_EXPERTISE_FIELDS.COMPENSATION_AMOUNT]: undefined,
  [APPEAL_CIVIL_MEDICAL_EXPERTISE_FIELDS.DOCUMENT]: {},
};
export const EMPTY_APPEAL_CIVIL_ACCOUNTING_EXPERTISE = {
  [APPEAL_CIVIL_ACCOUNTING_EXPERTISE_FIELDS.EVALUATION_AMOUNT]: undefined,
  [APPEAL_CIVIL_ACCOUNTING_EXPERTISE_FIELDS.DOCUMENT]: {},
};
export const EMPTY_APPEAL_CIVIL_MECHANICAL_EXPERTISE = {
  [APPEAL_CIVIL_MECHANICAL_EXPERTISE_FIELDS.DAMAGE_AMOUNT]: undefined,
  [APPEAL_CIVIL_MECHANICAL_EXPERTISE_FIELDS.DOCUMENT]: {},
};

export const JUDGEMENT_INFO_FIELDS = {
  DEPENS: 'responsibility',
  COST: 'cost',
  IDD: 'idd',
  DATE: 'calculationStartDate',
  COMMENTARY: 'commentary',
  DEFENSE_TO_EXECUTION: 'defenseToExecution',
  DIFFICULTY_TO_EXECUTION: 'difficultyToExecution',
} as const;
export const JUDGEMENT_BENEFICIARY_FIELDS = {
  PREJUDICE_MATERIEL: 'materialPrejudice',
  PREJUDICE_MORAL: 'moralePrejudice',
  JUDGEMENT_AMOUNT: 'judgementAmount',
} as const;
export const EMPTY_JUDGEMENT_INFO = {
  [JUDGEMENT_INFO_FIELDS.DEPENS]: '',
  [JUDGEMENT_INFO_FIELDS.COST]: '',
  [JUDGEMENT_INFO_FIELDS.IDD]: '',
  [JUDGEMENT_INFO_FIELDS.DATE]: '',
  [JUDGEMENT_INFO_FIELDS.COMMENTARY]: '',
  [JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION]: false,
  [JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION]: false,
};
export const FUNERAL_EXPENSES_FIELDS = {
  FUNERAL_EXPENSES: 'funeralExpenses',
} as const;
export const EMPTY_FUNERAL_COSTS = {
  [FUNERAL_EXPENSES_FIELDS.FUNERAL_EXPENSES]: 0,
};
export const EMPTY_JUDGEMENT_BENEFICIARY = {
  [JUDGEMENT_BENEFICIARY_FIELDS.PREJUDICE_MATERIEL]: 0,
  [JUDGEMENT_BENEFICIARY_FIELDS.PREJUDICE_MORAL]: 0,
};

export const FEE_NOTE = {
  ID: 'id',
  CLAIM_ID: 'claimId',
  STEP: 'step',
  AMOUNT_TTC: 'amountTtc',
  AMOUNT_HT: 'amountHt',
  STATUS: 'status',
  CREATED_BY: 'createdBy',
  BENEFICIARY: 'beneficiary',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  DOCUMENT: 'document',
  CLAIM: 'claim',
  REJECTION_REASON: 'rejection_reason',
  COMMENT: 'comment',
  COSTS: 'costs',
  DOCUMENT_TYPE: 'type',
} as const;

export const EMPTY_FEE_NOTE = {
  [FEE_NOTE.CLAIM_ID]: '',
  [FEE_NOTE.STEP]: '',
  [FEE_NOTE.AMOUNT_TTC]: '',
  [FEE_NOTE.AMOUNT_HT]: '',
  [FEE_NOTE.STATUS]: '',
  [FEE_NOTE.CREATED_BY]: '',
  [FEE_NOTE.BENEFICIARY]: '',
  [FEE_NOTE.CREATED_AT]: '',
  [FEE_NOTE.UPDATED_AT]: '',
  [FEE_NOTE.DOCUMENT]: EMPTY_DOCUMENT,
  [FEE_NOTE.CLAIM]: { [CLAIM.CLAIM_NUMBER]: '' },
  [FEE_NOTE.REJECTION_REASON]: '',
  [FEE_NOTE.COMMENT]: '',
};

export const ASSIGN_EXPERT = {
  PROCEDURE_NATURE_ID: 'procedureNatureId',
  STEP: 'step',
  EXPERT_NATURE: 'expertNature',
  ASSIGNED_EXPERT: 'assignedExpert',
  COURT_FILE_NUMBER: 'courtFileNumber',
  LAWYER: 'lawyer',
  LEGAL_EXPERT: 'legalExpert',
  TYPE: 'type',
  CITY: 'city',
  HOUR: 'hour',
  MISSION_DATE: 'missionDate',
  CLAIM_ID: 'claimId',
  VICTIMS: 'victims',
  ADDRESS: 'address',
  DOCUMENT: 'document',
  COMMENT: 'comment',
  VEHICLES: 'vehicles',
  JUDICIARY_PROCESS_ID: 'judiciaryProcessId',
  RECEIPT_DATE: 'receiptDate',
};
export const ASSIGN_EXPERT_PROVISIORE = {
  EXPERT_NATURE: 'expertNature',
  ASSIGNED_EXPERT: 'assignedExpert',
  TYPE: 'type',
  VICTIM_IDS: 'victimIds',
};
export const EMPTY_ASSIGN_EXPERT_PROVISIORE = {
  [ASSIGN_EXPERT_PROVISIORE.EXPERT_NATURE]: null,
  [ASSIGN_EXPERT_PROVISIORE.ASSIGNED_EXPERT]: null,
  [ASSIGN_EXPERT_PROVISIORE.TYPE]: null,
  [ASSIGN_EXPERT_PROVISIORE.VICTIM_IDS]: [],
};

export const EMPTY_ASSIGN_EXPERT = {
  [ASSIGN_EXPERT.PROCEDURE_NATURE_ID]: '',
  [ASSIGN_EXPERT.ASSIGNED_EXPERT]: '',
  [ASSIGN_EXPERT.EXPERT_NATURE]: '',
  [ASSIGN_EXPERT.STEP]: '',
  [ASSIGN_EXPERT.COURT_FILE_NUMBER]: '',
  [ASSIGN_EXPERT.TYPE]: '',
  [ASSIGN_EXPERT.CITY]: '',
  [ASSIGN_EXPERT.HOUR]: '',
  [ASSIGN_EXPERT.MISSION_DATE]: '',
  [ASSIGN_EXPERT.CLAIM_ID]: '',
  [ASSIGN_EXPERT.VICTIMS]: '',
  [ASSIGN_EXPERT.ADDRESS]: '',
  [ASSIGN_EXPERT.LEGAL_EXPERT]: '',
  [ASSIGN_EXPERT.DOCUMENT]: EMPTY_DOCUMENT,
  [ASSIGN_EXPERT.COMMENT]: '',
  [ASSIGN_EXPERT.VEHICLES]: '',
  [ASSIGN_EXPERT.JUDICIARY_PROCESS_ID]: '',
  [ASSIGN_EXPERT.RECEIPT_DATE]: '',
};

export const CONTESTATION_FIELDS = {
  OWNER: 'owner',
  AGAINST: 'against',
  COMMENT: 'commentary',
  LAWYER_OPINION: 'lawyerOpinion',
  TYPE: 'type',
  WITHDRAWAL_REASON: 'withdrawalReasonId',
};

export const CONTESTATION = {
  TYPE: 'type',
  WITHDRAWALREASON: 'withdrawalReasonId',
  OWNER: 'owner',
  AGAINST: 'against',
  COMMENTARY: 'commentary',
  DIFFICULTY_EXECUTION: 'difficultyExecution',
  DEFENSE_EXECUTION: 'defenseExecution',
} as const;

export const CONTESTATION_AGAINST = {
  VICTIM: 'Victime',
  VEHICLE: 'Vehicule',
} as const;
export const PARTIES_CLAIM_STATUS = {
  PENDING: 'PENDING',
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
};
export const MISSION_POSTPONE_STATUS = {
  PENDING: 'PENDING',
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
  ENATTENTE: 'EN ATTENTE',
  REALISEE: 'REALISEE',
  PENDING_APPRECIATION: 'PENDING_APPRECIATION',
  PV_DE_CARENCE: 'PV DE CARENCE',
  REPORT_EXPERTISE: "REPORT D'EXPERTISE",
  REJETEE_PAR_EXPERT: 'REJETEE PAR EXPERT',
  ENATTENTE_APPRECIATION: "EN ATTENTE D'APPRECIATION",
};
export const MISSION_POSTPONE_TYPE = {
  NOTICE_DEFICIENCY: 'PV de carence',
  POSTPONEMENTS_EXPERTISE: "Report d'expertise",
};
export const MISSION_EXPERISE_VICTIM_STATUS = {
  PENDING: 'PENDING',
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
};
export const MISSION_STATUS = {
  PENDING: 'PENDING',
  TRAITED: 'TRAITED',
  REJECTED: 'REJECTED',
  REJECTED_BY_EXPERT: 'REJECTED_BY_EXPERT',
};
export const FEE_NOTE_STEP = {
  EXPERTISE_CONSEIL: 'EXPERTISE_CONSEIL',
  NOTICE_DEFICIENCY: 'NOTICE_DEFICIENCY',
  EXPERTISE_CONSEIL_APPRECIATION: 'EXPERTISE_CONSEIL_APPRECIATION',
};

export const REJECTION_REASON = 'ETAPE JUDICIARE REJETEE';
export const JUDICIARY_PROCESS_CORRECTIONAL_ID = 3;
export const JUDICIARY_PROCESS_COMMERCIALE_ID = 1;
export const JUDICIARY_PROCESS_CIVILE_ID = 2;
export const INVOICE_INFO = {
  ID: 'id',
  INVOICE_NUMBER: 'invoiceNumber',
  INVOICE_DATE: 'invoiceDate',
  INVOICE_RECEPTION_DATE: 'receptionDate',
  URL: 'url',
  TYPE: 'type',
  NAME: 'name',
} as const;
export const EMPTY_INVOICE_INFO = {
  [INVOICE_INFO.INVOICE_NUMBER]: null,
  [INVOICE_INFO.INVOICE_DATE]: null,
  [INVOICE_INFO.INVOICE_RECEPTION_DATE]: null,
  [INVOICE_INFO.URL]: null,
  [INVOICE_INFO.TYPE]: null,
  [INVOICE_INFO.NAME]: null,
};

export const EMPTY_ASSIGN_EXPERT_TRANSACTION = {
  [ASSIGN_EXPERT.ASSIGNED_EXPERT]: '',
  [ASSIGN_EXPERT.EXPERT_NATURE]: '',
  [ASSIGN_EXPERT.TYPE]: '',
  [ASSIGN_EXPERT.MISSION_DATE]: '',
  [ASSIGN_EXPERT.CLAIM_ID]: '',
  [ASSIGN_EXPERT.VICTIMS]: '',
};

export const OPPOSING_LAWYER_FIELDS = {
  NAME: 'name',
  ADRESS: 'address',
  CITY: 'city',
  EMAIL: 'email',
};

export const PROVISIONAL_CLAIM = {
  PROCEDURE_NATURE_ID: 'procedureNatureId',
  JURISDICTION_DEGREE_ID: 'jurisdictionDegreeId',
  COURT_NUMBER: 'courtNumber',
  JURISDICTION_ID: 'jurisdictionId',
  HEARING_DATE: 'hearingDate',
  LAWYER_CODE: 'lawyerCode',
};

export const PROVISIONAL_CLAIM_STATUS = {
  PENDING: 'PENDING',
  MAPPED: 'MAPPED',
};

export const EMPTY_PROVISIONAL_CLAIM = {
  [PROVISIONAL_CLAIM.PROCEDURE_NATURE_ID]: null,
  [PROVISIONAL_CLAIM.JURISDICTION_DEGREE_ID]: null,
  [PROVISIONAL_CLAIM.COURT_NUMBER]: null,
  [PROVISIONAL_CLAIM.JURISDICTION_ID]: null,
  [PROVISIONAL_CLAIM.HEARING_DATE]: null,
  [PROVISIONAL_CLAIM.LAWYER_CODE]: null,
};
